module.exports = __webpack_public_path__ + "static/hundreds-logo-3fee5e09a2e6d8d330fc105abe83ad8e.svg";